import Spinner from '@zg-rentals/multibrand-ui/lib/Spinner';
import React from 'react';

import './index.scss';

const SpinnerContainer = (props) => (
  <div className="spinnerParentBackground">
    <div className="spinnerChild">
      <Spinner {...props} />
    </div>
  </div>
);

export default SpinnerContainer;
